import { render, staticRenderFns } from "./LinkedinConnect.vue?vue&type=template&id=2c69427b&scoped=true"
import script from "./LinkedinConnect.vue?vue&type=script&lang=js"
export * from "./LinkedinConnect.vue?vue&type=script&lang=js"
import style0 from "./LinkedinConnect.vue?vue&type=style&index=0&id=2c69427b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c69427b",
  null
  
)

export default component.exports